import _ from 'lodash';
import { useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';

const TextMark = ({texto = '', textMark = ''}) => {
    const [textArrSearch, setTextArrSearch] = useState([]);
    useEffect(() => {
        if(textMark){
            const separador = textMark.split(' ')
            setTextArrSearch(separador)
        }
    }, [textMark])
    if (!textMark.trim()) return <span>{texto}</span>;
    return (
        <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={textArrSearch}
            autoEscape={true}
            textToHighlight={texto}
        />
    )
}

export default TextMark
